<script setup>
import { ref, defineExpose } from "vue";

defineProps({
  isOpenPanel: Boolean,
});

const panelDesktop = ref(null)
// const baseUrl = process.env.VUE_APP_SISTEMA_SUBASTAS_ACTUAL_URL

defineExpose({ panelEl: panelDesktop })
</script>

<template>
  <ul
    
    class="dropdown-menu shadow border-0 mt-0 rounded-1"
    :class="{ 'show': isOpenPanel }"
    style="width: 300px;"
    aria-labelledby="userDropdown"
  >
    <hr class="dropdown-divider" />
    <li><a class="dropdown-item fw-bold" href="/usuario">Inicio</a></li>
    <li><a class="dropdown-item fw-bold" href="/usuario/perfil">Perfil</a></li>
    <li><a class="dropdown-item fw-bold" href="/usuario/credito">Crédito</a></li>
    <li><a class="dropdown-item fw-bold" href="/usuario/historial">Historial de ofertas</a></li>
    <li><hr class="dropdown-divider" /></li>
    <li>
      <button class="dropdown-item d-flex align-items-center cursor-pointer">
        <a href="/logout"><i class="fa fa-sign-out me-2"></i>Cerrar sesión</a>
      </button>
    </li>
  </ul>
</template>

